

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_109_2_border";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_109_2_border__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"radius02":"2px","radius04":"4px","radius06":"6px","radius08":"8px","THEME-RADIUS-02":"var(--wsr-border-radius-02, 2px)","THEME-RADIUS-04":"var(--wsr-border-radius-04, 4px)","THEME-RADIUS-06":"var(--wsr-border-radius-06, 6px)","THEME-RADIUS-08":"var(--wsr-border-radius-08, 8px)"}; 
export var vars = {"wsr-border-radius-02":"--wsr-border-radius-02","wsr-border-radius-04":"--wsr-border-radius-04","wsr-border-radius-06":"--wsr-border-radius-06","wsr-border-radius-08":"--wsr-border-radius-08"}; 




